"use client";
import dynamic from "next/dynamic";
// import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
const GoogleReCaptchaProvider = dynamic(() =>
    import('react-google-recaptcha-v3').then((mod) => mod.GoogleReCaptchaProvider),
    { ssr: false }
  );
export const GoogleRecaptchaProvider = ({
    children,
    reCaptchaKey,
    isPageSpeed,
}: {
    children: React.ReactNode;
    reCaptchaKey: string | undefined;
    isPageSpeed: boolean;
}) => {
    if (isPageSpeed) {
        return <>{children}</>;
    }
    return (
        <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey || ""}
        scriptProps={{
            async: true,
            defer: true,
            appendTo: "head",
        }}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
};
